import * as React from "react";

import { AccordionQuestionnaireSection } from "@teamprevent/common/questionnaires/components/AccordionQuestionnaireSection";
import { TextQuestion } from "@teamprevent/common/questionnaires/components/questions/TextQuestion";
import { DropdownQuestion } from "@teamprevent/common/questionnaires/components/questions/DropdownQuestion";

import { ClinicalNotesProps } from "../../../clinicalNotes/components/ClinicalNotes";
import { ohaMedicalClassificationOptions, medicalClassificationSubCategoryOptions } from "../../../clinicalNotes/models";
import { AddTasksInputs } from "../../../tasks/components/addTasksInputs";
import { AddNextTaskFormModel } from "../../../tasks/models";
import { TaskType } from "../../../task/model";

export interface OwnProps {
    ohCaseId: string;
    taskTypes: TaskType[];
    setTasks: (tasks: AddNextTaskFormModel[]) => void;
    isSubmitted: boolean;
}

type AllProps = ClinicalNotesProps & OwnProps;

const GenericCaseClinicalNotesSections: React.FunctionComponent<AllProps> = (props: AllProps) => {

    const getAnswerToQuestionWithId = (id: string) => {
        return props.questions?.find(question => question.id === id)?.answer;
    };

    return (
        <>
            <AccordionQuestionnaireSection
                title="Clinical Notes"
                id="ClinicalNotes"
                index={props.index}
            >
                <TextQuestion
                    readonly={props.readonly}
                    questionConfig={({ id: "ClinicalNotes", questionText: "Clinical Notes" })}
                    mandatory
                    multiline
                />
                <DropdownQuestion
                    inline
                    readonly={props.readonly}
                    filterOldOptions
                    questionConfig={({ id: "MedicalClassification", questionText: "Medical Classification" })}
                    options={ohaMedicalClassificationOptions.sort((a, b) => a.text.localeCompare(b.text))}
                />
                {medicalClassificationSubCategoryOptions[getAnswerToQuestionWithId("MedicalClassification") as string]
                    && <DropdownQuestion
                        inline
                        readonly={props.readonly}
                        filterOldOptions
                        questionConfig={({ id: "MedicalClassificationSubCategory", questionText: "Classification Sub Category" })}
                        options={medicalClassificationSubCategoryOptions[getAnswerToQuestionWithId("MedicalClassification") as string]
                            .sort((a, b) => a.text.localeCompare(b.text))}
                    />}
            </AccordionQuestionnaireSection>
            {props.readonly ? null :
                <AccordionQuestionnaireSection
                    title="Next Task"
                    id="NextTask"
                    hideNextButton={true}
                    active={true}
                    neverHide={true}
                >
                    <AddTasksInputs
                        taskTypes={props.taskTypes}
                        onChange={props.setTasks}
                        ohCaseId={props.ohCaseId}
                        showErrors={props.isSubmitted}
                        assignmentOptionRequired={true}
                    />
                </AccordionQuestionnaireSection>
            }
        </>
    );
};

export { GenericCaseClinicalNotesSections };
